import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-dash-explicit-appli-container',
    templateUrl: './dash-explicit-appli-container.component.html',
    styleUrls: [
        './dash-explicit-appli-container.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashExplicitAppliContainerComponent
{
    @Input() iconClass: string;
    @Input() title: string;
}
